import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Text from './Resources/Text'
import registerServiceWorker from './registerServiceWorker';


ReactDOM.render(
	<App appText={Text}/>,
	document.getElementById('root'));


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js